import { render } from "./VerifyEmailDialogHOC.vue?vue&type=template&id=2be3f22c"
import script from "./VerifyEmailDialogHOC.vue?vue&type=script&lang=js"
export * from "./VerifyEmailDialogHOC.vue?vue&type=script&lang=js"
script.render = render

export default script